import React from 'react';
import { RecordLabelCell } from '../components/workflow/CoverageDisplay';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { submitKeysOf } from '../components/workflow/useWorkflowPerms';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import ReviewerLapsedNote from '../components/workflow/ReviewerLapsedNote';
import { formatDateShort } from '../utils/dateFormat';

// QC Amendment — list page (docs/modules/workflow-qc.md §8, docs/workflow-ui.md).
const WorkflowQca = () => {
  const { hasPermission } = useAuth();
  return (
    <WorkflowListShell
      title="QC Amendment"
      subtitle="Corrections to approved QC6 / QC7 records."
      newTo="/workflow/qca/new"
      canCreate={submitKeysOf('qca').some(hasPermission)}
      apiPath="/api/workflow/qca"
      searchPlaceholder="Search request no / requester…"
      width="mid"
      rowTo={(r) => `/workflow/qca/${r.id}`}
      columns={[
        {
          key: 'requestNo',
          label: 'Request',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/qca/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'recordLabel', label: 'QC Record', sortKey: 'recordLabel', render: (r) => <RecordLabelCell label={r.recordLabel} items={r.recordEngagements} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => (<><WorkflowStatusBadge status={r.status} /><ReviewerLapsedNote when={r.reviewerLapsed} /></>) },
        { key: 'requester', label: 'Requested By', className: 'text-slate-600', render: (r) => r.requesterEmail },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowQca;
